import HOCWatchValue from 'components/common/hoc-watch-value';
import * as React from 'react';

import ActivityGuestCard from './activity/items';
import CruiseItems from './cruise/items';
import DocumentItems from './document';
import FlightSaleItems from './flight/items';
import HotelSaleHotelSection from './hotel/items';
import ProductCard from './product/product-card';
import TourCard from './tour/tour-card';

export default function SaleItems() {
  const values = HOCWatchValue({
    keys: ['approvalable.status', 'approvalable.transactionType'],
  });
  const transactionType = values['approvalable.transactionType'];

  if (transactionType === 'flight') {
    return <FlightSaleItems />;
  }
  if (transactionType === 'activity') {
    return <ActivityGuestCard />;
  }
  if (transactionType === 'cruise') {
    return <CruiseItems />;
  }

  if (transactionType === 'hotel') {
    return <HotelSaleHotelSection />;
  }

  if (transactionType === 'document') {
    return <DocumentItems />;
  }

  if (transactionType === 'tour') {
    return <TourCard />;
  }

  if (transactionType === 'product') {
    return <ProductCard />;
  }

  return null;
}
